module.exports = __webpack_public_path__ + "img/deftime.9a6b2bf7.png";